"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_ATTENDEE_PREFIX = void 0;
exports.AWS_ATTENDEE_PREFIX = 'aws:';
//# sourceMappingURL=constants.js.map